<template>
  <path
    d="M2 2.5C2 1.67157 2.65665 1 3.46667 1H11.5333C12.3434 1 13 1.67157 13 2.5V14.5C13 15.3284 12.3434 16 11.5333 16H3.46667C2.65665 16 2 15.3284 2 14.5V2.5Z"
    fill="#92AEEA"
  />
  <path
    d="M3 1.5C3 0.671573 3.65665 0 4.46667 0H12.5333C13.3434 0 14 0.671573 14 1.5V13.5C14 14.3284 13.3434 15 12.5333 15H4.46667C3.65665 15 3 14.3284 3 13.5V1.5Z"
    fill="#3769D6"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M8 3.66667C8 3.29848 8.29848 3 8.66667 3C9.03486 3 9.33333 3.29848 9.33333 3.66667V4.33333H8V3.66667ZM10 4.3335H8C6.89543 4.3335 6 5.22893 6 6.3335C6 7.43807 6.89543 8.3335 8 8.3335H9.33333C9.70152 8.3335 10 8.63197 10 9.00016C10 9.36835 9.70152 9.66683 9.33333 9.66683H7.33333C6.96514 9.66683 6.66667 9.96531 6.66667 10.3335C6.66667 10.7017 6.96514 11.0002 7.33333 11.0002H8V11.6667C8 12.0349 8.29848 12.3333 8.66667 12.3333C9.03486 12.3333 9.33333 12.0349 9.33333 11.6667L9.33333 11.0002C10.4379 11.0002 11.3333 10.1047 11.3333 9.00016C11.3333 7.89559 10.4379 7.00016 9.33333 7.00016H8C7.63181 7.00016 7.33333 6.70169 7.33333 6.3335C7.33333 5.96531 7.63181 5.66683 8 5.66683H10C10.3682 5.66683 10.6667 5.36835 10.6667 5.00016C10.6667 4.63197 10.3682 4.3335 10 4.3335Z"
    fill="#EDF4FE"
  />
</template>
